import React from 'react'
import PopoverTooltip from './PopoverTooltip'

export default function RecessInlineNote({ label = 'summer recess in effect', tooltip }) {
  return (
    <div className='recess-inline-note dome-d-flex dome-align-center dome-justify-center dome-gap6 dome-p3'>
      {tooltip && (
        <PopoverTooltip content={tooltip}>
          <i className='fal fa-circle-exclamation' />
        </PopoverTooltip>
      )}
      <span>{label}</span>
    </div>
  )
}
